export const scalingStyles = {
    contain: {
        objectFit: 'contain',
        maxWidth: '100%',
    },
    fullyContain: {
        objectFit: 'contain',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
    },
    cover: {
        objectFit: 'cover',
    },
} as const;
